import exp from "constants";
import DropdownOptions from "./quote-outcome.json";


export const getSourcesForAgents = (): string[] => {
  return DropdownOptions.sources;
};

export const getLeadSourcesForAgents = (): string[] => {
  return DropdownOptions.leadSources;
};

export const getLanguagesForAgents = (): string[] => {
  return DropdownOptions.languages;
};

export const getTypeOfQuote = (outcomeSelected: string): string[] => {
  if (outcomeSelected === "Quote") {
    return DropdownOptions.typeOfQuoteForQuoted;
  } else if (outcomeSelected === "Not Quoted") {
    return DropdownOptions.typeOfQuoteForNotQuoted;
  } else if (outcomeSelected === "Follow-Up") {
    return DropdownOptions.typesForFollowUp;
  }
  else {
    return [];
  }
};

export const getTypeOfSecondaryQuote = (): string[] => {
  return DropdownOptions.typesOfMisredirect;
}